import { onBeforeUnmount, ref, watch } from 'vue'

const TYPE_SPEED_MS = 45

// Types the new text out when it changes for the same key (a title renamed in place), shows it at once otherwise.
export const useTypewriter = (text, key = () => null) => {
  const displayed = ref(text())
  let timer = null

  watch([text, key], ([value, currentKey], [previousValue, previousKey]) => {
    clearInterval(timer)
    if (currentKey !== previousKey || !value || !previousValue) {
      displayed.value = value
      return
    }
    if (value === previousValue) return
    let typed = 0
    displayed.value = ''
    timer = setInterval(() => {
      displayed.value = value.slice(0, ++typed)
      if (typed >= value.length) clearInterval(timer)
    }, TYPE_SPEED_MS)
  })

  onBeforeUnmount(() => clearInterval(timer))

  return displayed
}
